// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// Internal Dependencies:
// import SearchBar from 'components/Search/SearchBar'
const currentYear = siteData.current_year

// Redux:
import { openSearch, closeSearch, search } from 'actions/search'

class Footer extends React.Component {
	render() {
		return (
			<footer className="footer">
				<div className="-inner">
					<div className="-a">
						<p>
							<Link to="/about">About</Link> / <Link to="/contact">Contact</Link> / <Link to="/meet-the-team">Meet the Team</Link><br />
							Copyright &copy; { currentYear } Seventh-day Adventist Church Australia
							<br />
							Website by <a className="plain" href="http://alexgreendesign.com" target="_blank">Alex Green Design</a>
						</p>
					</div>

					<div className="-b">
						<div className="-social">
							<a href="https://www.facebook.com/myedgemag/" target="_blank" rel="noopener">
								<i className="icon-facebook-square" arua-hidden="true"></i>
								<div className="-text">Facebook</div>
							</a>

							<a href="https://www.instagram.com/myedgemag/" target="_blank" rel="noopener">
								<i className="icon-instagram" arua-hidden="true"></i>
								<div className="-text">Instagram</div>
							</a>
						</div>
					</div>
				</div>
			</footer>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {

	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {

	}
}

export default connect( mapStateToProps, mapDispatchToProps )( Footer )
